var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcrDocumentRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12248_139093",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12248_139093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19928 11.9996H9.79523C9.96505 11.9996 10.1083 11.9424 10.225 11.8281C10.3416 11.7138 10.4 11.5721 10.4 11.4031C10.4 11.2341 10.3425 11.0913 10.2277 10.9746C10.1128 10.8579 9.97043 10.7996 9.80062 10.7996H6.20467C6.03486 10.7996 5.89162 10.8568 5.77495 10.9711C5.65828 11.0854 5.59995 11.2271 5.59995 11.3961C5.59995 11.5651 5.65738 11.7079 5.77225 11.8246C5.88713 11.9413 6.02947 11.9996 6.19928 11.9996ZM6.19928 9.59961H9.79523C9.96505 9.59961 10.1083 9.54245 10.225 9.42813C10.3416 9.31379 10.4 9.17213 10.4 9.00313C10.4 8.83412 10.3425 8.69128 10.2277 8.57461C10.1128 8.45794 9.97043 8.39961 9.80062 8.39961H6.20467C6.03486 8.39961 5.89162 8.45677 5.77495 8.57109C5.65828 8.68543 5.59995 8.82709 5.59995 8.99609C5.59995 9.1651 5.65738 9.30794 5.77225 9.42461C5.88713 9.54128 6.02947 9.59961 6.19928 9.59961ZM4.39523 14.3996C4.06505 14.3996 3.78328 14.2821 3.54995 14.0471C3.31662 13.8121 3.19995 13.5296 3.19995 13.1996V2.79961C3.19995 2.46961 3.31745 2.18711 3.55245 1.95211C3.78745 1.71711 4.06995 1.59961 4.39995 1.59961H9.09995C9.25797 1.59961 9.40859 1.62739 9.5518 1.68294C9.69501 1.7385 9.82773 1.82739 9.94995 1.94961L12.45 4.44961C12.5722 4.57183 12.6611 4.70455 12.7166 4.84776C12.7722 4.99097 12.8 5.14159 12.8 5.29961V13.1996C12.8 13.5296 12.6824 13.8121 12.4473 14.0471C12.2121 14.2821 11.9295 14.3996 11.5993 14.3996H4.39523ZM8.79995 4.99961V2.79961H4.39995V13.1996H11.6V5.59961H9.39995C9.22995 5.59961 9.08745 5.54211 8.97245 5.42711C8.85745 5.31211 8.79995 5.16961 8.79995 4.99961Z",
    fill: "#ED0529"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrDocumentRed);
export default __webpack_public_path__ + "static/media/ocr-document-red.631c6cfc7077d36f54b5b009f45d1ecb.svg";
export { ForwardRef as ReactComponent };